import { render, staticRenderFns } from "./artist.vue?vue&type=template&id=f20e8d16&scoped=true&"
import script from "./artist.vue?vue&type=script&lang=ts&"
export * from "./artist.vue?vue&type=script&lang=ts&"
import style0 from "./artist.vue?vue&type=style&index=0&id=f20e8d16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20e8d16",
  null
  
)

export default component.exports